const small = '0.7'
const middle = '1'
const large = '1.3'

module.exports = [
	{ text: 'SETTINGS.zoom_scale.small', value: small },
	{ text: 'SETTINGS.zoom_scale.middle', value: middle },
	{ text: 'SETTINGS.zoom_scale.large', value: large }
]
